
const store = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'rr-screen-page'
    }
  },
  getters: {},
  mutations: {
  },
  actions: {
  }
}

export default store
